export function printPage() {
    window.print();
}

export function copyCurrentURL() { //Works only on https
  const url = window.location.href;
  navigator.clipboard.writeText(url).then(() => {
      alert("URL copied !");
  }).catch(err => {
      console.error("Erreur lors de la copie : ", err);
  });
}
